import React from "react";
import profile from './profile-pic.jpg'
import "../styles/Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top">
      <div className="container flex-lg-column">
        <a href="navbar-brand mx-lg-auto mb-lg-">
          <span className="fs-3 fw-bold d-block d-lg-none">Afeef Ali</span>
          <div className="brand mb-lg-5">
            {/* =============profile-img============== */}
            <img
              src={profile}
              id="inner-img"
              className="d-none d-lg-block rounded-circle"
              alt=""
            />
            <h4 className="text-center mt-2 d-none d-lg-block">Afeef Ali</h4>
          </div>
        </a>
        {/* ===============collaspe button============ */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        {/* ==================nav-items============= */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto flex-lg-column text-lg-center">
            {/* ============1============ */}
            <li className="nav-item">
              <a className="nav-link" href="/">
                Home
              </a>
            </li>
            {/* =================2==================== */}
            <li className="nav-item">
            
              <a className="nav-link" href="#about">
                About
              </a>
            </li>
            {/* ===================3================= */}
            <li className="nav-item">
            <a className="nav-link" href="#service">
                Services
              </a>
            </li>
            {/* ==============4=============== */}
            <li className="nav-item">
          
              <a className="nav-link" href="#resume">
                Resume
              </a>
            </li>
            {/* =================5================== */}
            <li className="nav-item">
            <a className="nav-link" href="#work">
                Work
              </a>
            </li>
            {/* =====================6================= */}
            <li className="nav-item">
            <a className="nav-link" href="#slider">
                Reviews
              </a>
            </li>
            {/* ====================7================= */}
            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
